<template>
  <swiper
    :slides-per-view="1.25"
    :space-between="8"
    :centeredSlides="true"
    :loop="true"
    :slideToClickedSlide="true"
  >
    <swiper-slide v-for="(image, ind) in $halllist[galid].img" :key="ind">
      <div class="imgwrap">
        <img
          :src="require('../assets/images/' + galid + '/' + image[0])"
          :alt="image[1]"
        />
        <p class="caption">
          {{ image[1] }}
        </p>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
// Import Swiper styles
export default {
  data() {
    return {
      modalstate: false,
      modalimage: "",
    };
  },
  props: ["galid"],
  components: {
    Swiper,
    SwiperSlide,
  },
};
</script>
<style lang="scss" scoped>
h4 {
  background-color: #ceecff;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
  img {
    width: 40px;
    height: 40px;
    margin-right: 1rem;
  }
}
.imgwrap {
  position: relative;
  aspect-ratio: 16/9;
  cursor: pointer;
  background-color: black;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 0;
    opacity: 0.5;
    transition: 0.5s;
    transition-delay: 0.5s;
  }
  .caption {
    position: absolute;
    padding: 0.25rem 1rem;
    z-index: 1;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: $color-hondo;
    opacity: 0;
    transition: 0.5s;
    transition-delay: 0.5s;
  }
}
.swiper-slide-active {
  img {
    opacity: 1;
  }
  .caption {
    opacity: 1;
  }
}
</style>
